import React, { type ComponentProps } from 'react';
import c from 'classnames';

import { useDialogDrawerContext } from '../../../context/DialogDrawerContext';
import Button from '../../Button';

export interface DialogDrawerButtonProps extends ComponentProps<typeof Button> {
  className?: string;
  children: React.ReactNode;
  onClick?: () => void;
}

const DialogDrawerButton: React.FC<DialogDrawerButtonProps> = (props) => {
  const { openDialog } = useDialogDrawerContext();

  const {
    className,
    children,
    onClick,
    ...restProps
  } = props;

  const classNames = c('DialogDrawer__Button', className);

  return (
    <Button
      {...restProps}
      className={classNames}
      onClick={() => {
        openDialog();

        if (onClick) {
          onClick();
        }
      }}
    >
      {children}
    </Button>
  );
};

export default DialogDrawerButton;
